// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_math from "rescript/lib/es6/js_math.js";
import * as TcUtils from "../team-comps/TcUtils.bs.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as UnitImageExtended from "common/src/tft-static/UnitImageExtended.bs.js";
import * as Belt_MutableMapString from "rescript/lib/es6/belt_MutableMapString.js";

function decode(con, allUnits, allTraits, set) {
  switch (con.length) {
    case 1 :
        var v = con[0];
        if (Belt_Option.isSome(Js_dict.get(Data.augments(set), v))) {
          return {
                  TAG: /* Augment */4,
                  _0: v
                };
        }
        if (Belt_Option.isSome(Js_dict.get(Data.items(set), v))) {
          return {
                  TAG: /* Item */3,
                  _0: v
                };
        }
        var split = v.split("-");
        if (split.length <= 1) {
          return {
                  TAG: /* Unit */0,
                  _0: "TFT8_Poppy",
                  _1: 1
                };
        }
        var id = Belt_Array.getExn(split, 0);
        var rank = Belt_Option.getExn(Belt_Int.fromString(Belt_Array.getExn(split, 1)));
        if (allUnits.includes(id)) {
          return {
                  TAG: /* Unit */0,
                  _0: id,
                  _1: rank
                };
        } else if (allTraits.includes(id)) {
          return {
                  TAG: /* Trait */1,
                  _0: id,
                  _1: rank
                };
        } else {
          return {
                  TAG: /* Unit */0,
                  _0: "TFT8_Poppy",
                  _1: 1
                };
        }
    case 2 :
        return {
                TAG: /* Unit */0,
                _0: "TFT8_Poppy",
                _1: 1
              };
    case 3 :
        var unitId = con[0];
        var item1 = con[1];
        var item2 = con[2];
        var unitId$1 = Belt_Array.getExn(unitId.split("-"), 0);
        return {
                TAG: /* UnitItems */2,
                _0: unitId$1,
                _1: Belt_Option.getExn(Belt_Int.fromString(item1)),
                _2: Belt_Option.getExn(Belt_Int.fromString(item2))
              };
    default:
      return {
              TAG: /* Unit */0,
              _0: "TFT8_Poppy",
              _1: 1
            };
  }
}

function Tc2WinCons$Val(Props) {
  var val = Props.val;
  switch (val.TAG | 0) {
    case /* Unit */0 :
        return React.createElement(UnitImageExtended.make, {
                    size: 40,
                    unitId: val._0,
                    starLevel: val._1,
                    items: []
                  });
    case /* Trait */1 :
        var rank = val._1;
        var traitId = val._0;
        return React.createElement(TraitTooltip.make, {
                    trait: traitId,
                    rank: rank,
                    children: React.createElement(TraitImage.PlainIcon2.make, {
                          traitId: traitId,
                          rank: rank,
                          size: 40
                        })
                  });
    case /* UnitItems */2 :
        return React.createElement(UnitImageExtended.make, {
                    size: 40,
                    unitId: val._0,
                    itemSize: 17,
                    items: [
                      String(val._1),
                      String(val._2)
                    ]
                  });
    case /* Item */3 :
        return React.createElement(ItemImage.make, {
                    itemId: val._0,
                    size: 40
                  });
    case /* Augment */4 :
        return React.createElement(AugmentImage.make, {
                    augId: val._0,
                    size: 40
                  });
    
  }
}

var Val = {
  make: Tc2WinCons$Val
};

function Tc2WinCons(Props) {
  var winCons = Props.winCons;
  var group = Props.group;
  var set = TftSet.use(undefined);
  var t = Translation.useT(/* Common */0);
  TcUtils.getTopAugments(group, set);
  var unitItems = Belt_SortArray.stableSortBy(Belt_Array.keep(group.unitItemPairs, (function (i) {
              var unitCount = Belt_Array.reduce(Belt_Array.keep(group.units, (function (param) {
                          return param[0] === i.unitId;
                        })), 0, (function (acc, param) {
                      return acc + param[2] | 0;
                    }));
              var unitCount$1 = Js_math.ceil(Math.sqrt(Global.f(unitCount) * Global.f(group.count)));
              if (Global.f(i.count) / Global.f(unitCount$1) >= 0.025) {
                return true;
              }
              var c1 = Belt_Option.mapWithDefault(Caml_option.undefined_to_opt(group.unitItems.find(function (v) {
                            return v.itemId === Belt_Array.getExn(i.items, 0);
                          })), 0, (function (v) {
                      return v.count;
                    }));
              var c2 = Belt_Option.mapWithDefault(Caml_option.undefined_to_opt(group.unitItems.find(function (v) {
                            return v.itemId === Belt_Array.getExn(i.items, 1);
                          })), 0, (function (v) {
                      return v.count;
                    }));
              return Global.f(c1) * Global.f(c2) / Global.f(unitCount$1) / Global.f(unitCount$1) >= 0.075;
            })), (function (i1, i2) {
          var uid1 = Belt_Array.getExn(i1.unitId.split("-"), 0);
          var uid2 = Belt_Array.getExn(i2.unitId.split("-"), 0);
          return Caml.caml_float_compare(T.calcSafePlace(undefined, i1.place, i1.count) + (
                      Sd.unitTier(uid1) === 5 ? 0.5 : 0
                    ), T.calcSafePlace(undefined, i2.place, i2.count) + (
                      Sd.unitTier(uid2) === 5 ? 0.5 : 0
                    ));
        }));
  var unitCount = Belt_MutableMapString.make(undefined);
  var unitItemCount = Belt_MutableMapString.make(undefined);
  var filteredUi = [];
  Belt_Array.forEach(unitItems, (function (ui) {
          var curr = Belt_MutableMapString.getWithDefault(unitCount, ui.unitId, 0);
          var uiId1 = ui.unitId + Belt_Array.getExn(ui.items, 0);
          var uiId2 = ui.unitId + Belt_Array.getExn(ui.items, 1);
          var uiId2$1 = uiId1 === uiId2 ? "0" : uiId2;
          var curr1 = Belt_MutableMapString.getWithDefault(unitItemCount, uiId1, 0);
          var curr2 = Belt_MutableMapString.getWithDefault(unitItemCount, uiId2$1, 0);
          if (curr < 4 && curr1 < 3 && curr2 < 3) {
            filteredUi.push(ui);
            Belt_MutableMapString.set(unitCount, ui.unitId, curr + 1 | 0);
            Belt_MutableMapString.set(unitItemCount, uiId1, curr + 1 | 0);
            return Belt_MutableMapString.set(unitItemCount, uiId2$1, curr + 1 | 0);
          }
          
        }));
  var topItems = Belt_SortArray.stableSortBy(Belt_Array.slice(filteredUi, 0, 10), (function (i1, i2) {
          return Caml.caml_float_compare(i1.place, i2.place);
        }));
  var topUnits = Belt_SortArray.stableSortBy(Belt_Array.slice(Belt_SortArray.stableSortBy(Belt_Array.keep(Belt_Array.keep(group.units, (function (param) {
                          var starLevel = param[1];
                          var tier = Sd.unitTier(param[0]);
                          if (tier !== 4) {
                            if (tier !== 5) {
                              return starLevel > 1;
                            } else {
                              return true;
                            }
                          } else {
                            return starLevel === 2;
                          }
                        })), (function (param) {
                      return Global.f(param[2]) / Global.f(group.count) >= 0.02;
                    })), (function (param, param$1) {
                  return Caml.caml_float_compare(T.calcSafePlace(undefined, param[3], param[2]), T.calcSafePlace(undefined, param$1[3], param$1[2]));
                })), 0, 10), (function (param, param$1) {
          return Caml.caml_float_compare(param[3], param$1[3]);
        }));
  Belt_SortArray.stableSortBy(Belt_Array.slice(Belt_SortArray.stableSortBy(Belt_Array.keep(group.traits, (function (param) {
                      return Global.f(param[2]) / Global.f(group.count) >= 0.02;
                    })), (function (param, param$1) {
                  return Caml.caml_float_compare(T.calcSafePlace(undefined, param[3], param[2]), T.calcSafePlace(undefined, param$1[3], param$1[2]));
                })), 0, 10), (function (param, param$1) {
          return Caml.caml_float_compare(param[3], param$1[3]);
        }));
  var allUnits = Sd.allUnits(set);
  var allTraits = Sd.allTraits(set);
  var filteredWinCons = [];
  var units = Belt_MutableMapString.make(undefined);
  var traits = Belt_MutableMapString.make(undefined);
  Belt_Array.forEach(winCons, (function (x) {
          var wc1 = decode(x[0], allUnits, allTraits, set);
          var wc2 = decode(x[1], allUnits, allTraits, set);
          var pass1;
          switch (wc1.TAG | 0) {
            case /* Unit */0 :
            case /* Trait */1 :
                pass1 = true;
                break;
            default:
              pass1 = true;
          }
          var pass2;
          switch (wc2.TAG | 0) {
            case /* Unit */0 :
            case /* Trait */1 :
                pass2 = true;
                break;
            default:
              pass2 = true;
          }
          if (!(pass1 && pass2)) {
            return ;
          }
          filteredWinCons.push(x);
          switch (wc1.TAG | 0) {
            case /* Unit */0 :
                var id = wc1._0 + String(wc1._1);
                Belt_MutableMapString.update(units, id, (function (v) {
                        return Belt_Option.getWithDefault(v, 0) + 1 | 0;
                      }));
                break;
            case /* Trait */1 :
                var id$1 = wc1._0 + String(wc1._1);
                Belt_MutableMapString.update(traits, id$1, (function (v) {
                        return Belt_Option.getWithDefault(v, 0) + 1 | 0;
                      }));
                break;
            default:
              
          }
          switch (wc2.TAG | 0) {
            case /* Unit */0 :
                var id$2 = wc2._0 + String(wc2._1);
                return Belt_MutableMapString.update(units, id$2, (function (v) {
                              return Belt_Option.getWithDefault(v, 0) + 1 | 0;
                            }));
            case /* Trait */1 :
                var id$3 = wc2._0 + String(wc2._1);
                return Belt_MutableMapString.update(traits, id$3, (function (v) {
                              return Belt_Option.getWithDefault(v, 0) + 1 | 0;
                            }));
            default:
              return ;
          }
        }));
  var topWinCons = Belt_SortArray.stableSortBy(Belt_Array.slice(filteredWinCons, 0, 10), (function (param, param$1) {
          return Caml.caml_float_compare(param[3], param$1[3]);
        }));
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "pb-4 pt-10 font-montserrat font-medium text-xl"
                }, t("Win Conditions")), React.createElement("div", {
                  className: "grid items-center gap-y-5 grid-cols-[repeat(6,1fr)] sm:grid-cols-[90px_repeat(10,1fr)]"
                }, React.createElement("div", {
                      className: "col-span-2 sm:col-span-1"
                    }, t("Units")), Belt_Array.map(Belt_Array.slice(topUnits, 0, 10), (function (param) {
                        var starLevel = param[1];
                        var unitId = param[0];
                        return React.createElement("div", {
                                    key: unitId + String(starLevel),
                                    className: "flex flex-col items-center text-xs"
                                  }, React.createElement(UnitImageExtended.make, {
                                        size: 40,
                                        unitId: unitId,
                                        starLevel: starLevel,
                                        items: []
                                      }), React.createElement("div", {
                                        className: "mt-[3px]"
                                      }, Global.formatPct(undefined, Global.f(param[2]) / Global.f(group.count)) + "%"), React.createElement("div", undefined, Global.toFixed(undefined, param[3])));
                      })), React.createElement("div", {
                      className: "col-span-2 sm:col-span-1"
                    }, t("Items")), Belt_Array.map(Belt_Array.range(0, 9), (function (idx) {
                        var d = Belt_Array.get(topItems, idx);
                        if (d === undefined) {
                          return React.createElement("div", {
                                      key: String(idx),
                                      className: "h-16"
                                    });
                        }
                        var d$1 = Caml_option.valFromOption(d);
                        return React.createElement("div", {
                                    key: String(idx),
                                    className: "flex flex-col items-center text-xs"
                                  }, React.createElement(UnitImageExtended.make, {
                                        size: 40,
                                        unitId: d$1.unitId,
                                        itemSize: 17,
                                        items: d$1.items
                                      }), React.createElement("div", {
                                        className: "mt-3"
                                      }, Global.formatPct(undefined, Global.f(d$1.count) / Global.f(group.count)) + "%"), React.createElement("div", undefined, Global.toFixed(undefined, d$1.place)));
                      })), React.createElement("div", {
                      className: "col-span-2 sm:col-span-1"
                    }, t("Combos")), Belt_Array.mapWithIndex(topWinCons, (function (idx, param) {
                        var v1 = decode(param[0], allUnits, allTraits, set);
                        var v2 = decode(param[1], allUnits, allTraits, set);
                        return React.createElement("div", {
                                    key: String(idx),
                                    className: "flex flex-col gap-2 items-center text-xs"
                                  }, React.createElement(Tc2WinCons$Val, {
                                        val: v1
                                      }), React.createElement(Tc2WinCons$Val, {
                                        val: v2
                                      }), React.createElement("div", {
                                        className: "pl-[2px] flex flex-col items-center font-montserrat font-medium"
                                      }, React.createElement("div", undefined, T.humanReadableCount(param[2])), React.createElement("div", {
                                            className: "mt-[2px]"
                                          }, Global.toFixed(undefined, param[3]))));
                      }))));
}

var make = React.memo(Tc2WinCons);

var imgSize = 40;

export {
  decode ,
  imgSize ,
  Val ,
  make ,
  
}
/* make Not a pure module */
